module.exports = __webpack_public_path__ + "static/media/imgFour.b8edf3ee.jpg";